import React, { useState, useCallback } from 'react';

import { Link } from '@landing/ui';
import BurgerBtn from './components/BurgerBtn';
import MobileMenu from './components/MobileMenu';
import AnchorMenu from './components/AnchorMenu';

import * as styles from './Header.module.scss';

export default function Header({ anchorLinks }) {
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

  const toggleMobileMenu = useCallback(() => {
    setMobileMenuVisible(!mobileMenuVisible);
  }, [mobileMenuVisible]);

  const onLinkClick = useCallback(() => {
    setMobileMenuVisible(false);
  }, []);

  return (
    <header className={styles.header}>
      <div className={styles.layout}>
        <Link href="https://andersenlab.com" className={styles.logoWrap}>
          <div className={styles.logo} />
        </Link>
        <AnchorMenu className={styles.navigation} anchorLinks={anchorLinks} />
        <div className={styles.touchPanel}>
          <BurgerBtn
            fixed={mobileMenuVisible}
            active={mobileMenuVisible}
            onClick={toggleMobileMenu}
          />
          {mobileMenuVisible && <MobileMenu anchorLinks={anchorLinks} onLinkClick={onLinkClick} />}
        </div>
      </div>
    </header>
  );
}
